const { SessionStoreModule } = await import("uidispatcher_api/UidispatcherApiModule");

export const SessionStore = SessionStoreModule.SessionStore;
export const LoginCustomerAction = SessionStoreModule.LoginCustomerAction;
export const LoginEmployeeAction = SessionStoreModule.LoginEmployeeAction;
export const LogoutManualAction = SessionStoreModule.LogoutManualAction;
